[
  {
    "id": 68,
    "name": "Guide to maintaining road worthiness",
    "url": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1151262/guide-to-maintaining-roadworthiness-commercial-goods-and-public-service-vehicles.pdf"
  },
  {
    "id": 69,
    "name": "EU Drivers Hours and tachographs goods vehicles",
    "url": "https://www.gov.uk/guidance/drivers-hours-goods-vehicles"
  },
  {
    "id": 70,
    "name": "Regulation 561/ 2006 Drivers hours rules",
    "url": "https://eur-lex.europa.eu/resource.html?uri=cellar:5cf5ebde-d494-40eb-86a7-2131294ccbd9.0005.02/DOC_1&format=PDF"
  },
  {
    "id": 71,
    "name": "Regulation 165/2014 Tachograph regulations",
    "url": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32014R0165"
  },
  {
    "id": 72,
    "name": "GB Domestic Drivers hours rules",
    "url": "https://www.gov.uk/drivers-hours/gb-domestic-rules"
  },
  {
    "id": 73,
    "name": "Northern Ireland Domestic Rules",
    "url": "https://www.infrastructure-ni.gov.uk/sites/default/files/publications/infrastructure/rules-on-drivers-hours-and-tachographs-goods-vehicles-nov20-v2.pdf"
  },
  {
    "id": 74,
    "name": "ROI Domestic Rules",
    "url": "https://www.irishstatutebook.ie/eli/1961/act/24/section/114/enacted/en/html"
  },
  {
    "id": 75,
    "name": "Stoneridge SE5000 tachograph training",
    "url": "https://www.se5000.com/training/"
  },
  {
    "id": 76,
    "name": "EU Mobility package 2020",
    "url": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32020R1054"
  },
  {
    "id": 77,
    "name": "Smart Tachograph 2 Regulations",
    "url": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32021R1228"
  }
]
